<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
    <g fill="none" fill-rule="evenodd">
        <circle cx="18" cy="18" r="18" :fill="globalColors.primary" fill-rule="nonzero"/>
        <path fill="#FFF" fill-rule="nonzero" d="M9 6h19v23H9z"/>
        <text :fill="globalColors.primary" font-family="AvenirNext-Bold, Avenir Next" font-size="10" font-weight="bold" transform="translate(9 6)">
            <tspan x="6.27" y="11">$</tspan>
        </text>
        <path :stroke="globalColors.primary" stroke-linecap="square" d="M13.5 21.5h10M13.5 24.25h10"/>
    </g>
</svg>

</template>
<script>
export default {
	name: 'billing-buy-car',
};
</script>




// WEBPACK FOOTER //
// billingBuyCar.vue?4d5dffbb